videojs.addLanguage('sl', {
  "Audio Player": "Avdio predvajalnik",
  "Video Player": "Video predvajalnik",
  "Play": "Predvajaj",
  "Pause": "Začasno ustavi",
  "Replay": "Predvajaj ponovno",
  "Current Time": "Trenutni čas",
  "Duration": "Trajanje",
  "Remaining Time": "Preostali čas",
  "Stream Type": "Vrsta podatkovnega toka",
  "LIVE": "V ŽIVO",
  "Seek to live, currently behind live": "Spremljaj v živo (trenutno v zaostanku)",
  "Seek to live, currently playing live": "Spremljaj v živo (trenutno v živo)",
  "Loaded": "Naloženo",
  "Progress": "Napredek",
  "Progress Bar": "Vrstica napredka",
  "progress bar timing: currentTime={1} duration={2}": "{1} od {2}",
  "Fullscreen": "Celozaslonski prikaz",
  "Non-Fullscreen": "Prikaz na delu zaslona",
  "Mute": "Izključi zvok",
  "Unmute": "Vključi zvok",
  "Playback Rate": "Hitrost predvajanja",
  "Subtitles": "Podnapisi",
  "subtitles off": "podnapisi izklopljeni",
  "Captions": "Zvočni zapis",
  "captions off": "zvočni zapis izklopljen",
  "Chapters": "Poglavja",
  "Descriptions": "Opisi",
  "descriptions off": "opisi izklopljeni",
  "Audio Track": "Zvočni posnetek",
  "Volume Level": "Raven glasnosti",
  "You aborted the media playback": "Prekinili ste predvajanje.",
  "A network error caused the media download to fail part-way.": "Prenos multimedijske datoteke ni uspel zaradi napake v omrežju.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Multimedijske datoteke ni bilo mogoče naložiti zaradi napake na strežniku oziroma omrežju ali ker ta oblika ni podprta.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Predvajanje datoteke je bilo prekinjeno zaradi napak v datoteki ali ker uporablja funkcije, ki jih brskalnik ne podpira.",
  "No compatible source was found for this media.": "Za to datoteko ni bil najden noben združljiv vir.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Datoteka je šifrirana in predvajalnik nima ključev za njeno dešifriranje.",
  "Play Video": "Predvajaj",
  "Close": "Zapri",
  "Close Modal Dialog": "Zapri modalno okno",
  "Modal Window": "Modalno okno",
  "This is a modal window": "To je modalno okno",
  "This modal can be closed by pressing the Escape key or activating the close button.": "To okno lahko zaprete s pritiskom na tipko Escape ali z aktiviranjem gumba za zapiranje.",
  ", opens captions settings dialog": ", odpre nastavitve za zvočni zapis",
  ", opens subtitles settings dialog": ", odpre nastavitve za podnapise",
  ", opens descriptions settings dialog": ", odpre nastavitve za opis",
  ", selected": ", izbrano",
  "captions settings": "nastavitve zvočnega zapisa",
  "subtitles settings": "nastavitve podnapisov",
  "descriptions settings": "nastavitve opisa",
  "Text": "Tekst",
  "White": "Bela",
  "Black": "Črna",
  "Red": "Rdeča",
  "Green": "Zelena",
  "Blue": "Modra",
  "Yellow": "Rumena",
  "Magenta": "Magenta",
  "Cyan": "Cian",
  "Background": "Ozadje",
  "Window": "Okno",
  "Transparent": "Prozorno",
  "Semi-Transparent": "Delno prozorno",
  "Opaque": "Neprozorno",
  "Font Size": "Velikost pisave",
  "Text Edge Style": "Slog roba besedila",
  "None": "Brez",
  "Raised": "Dvignjeno",
  "Depressed": "Vtisnjeno",
  "Uniform": "Enakomerno",
  "Dropshadow": "S senco",
  "Font Family": "Družina pisave",
  "Small Caps": "Male črke",
  "Reset": "Ponastavi",
  "restore all settings to the default values": "obnovi vse nastavitve na privzete vrednosti",
  "Done": "Končano",
  "Caption Settings Dialog": "Pogovorno okno za nastavitve zvočnega zapisa",
  "Beginning of dialog window. Escape will cancel and close the window.": "Začetek pogovornega okna. Escape bo preklical in zaprl okno.",
  "End of dialog window.": "Konec pogovornega okna.",
  "{1} is loading.": "{1} se nalaga.",
  "Exit Picture-in-Picture": "Izhod iz slike v sliki",
  "Picture-in-Picture": "Slika v sliki"
});